export default __webpack_public_path__ + "static/media/fourthCarouselImage.12b0e6fc.png";